import React from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "src/components/Dialog";
import { StatefulLoadableButton } from "src/components/LoadableButton";

interface ConfirmDialogProps {
  open: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

function ConfirmDialog({ open, onConfirm, onCancel }: ConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={() => onCancel()}>
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure to delete this Journal entry?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>No</Button>
        <StatefulLoadableButton
          onClick={async () => await onConfirm()}
          color="primary"
          variant="contained"
          autoFocus
        >
          Yes
        </StatefulLoadableButton>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
